import { Box, Flex, useTheme } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { TextHeader2 } from 'uiToolkitV1/Typography';

const Header = () => {
  const theme = useTheme();
  const { moduleName } = useOrganisationSettings();

  return (
    <Flex
      bgColor={theme.colors.surface.F5F7F9}
      alignItems="center"
      columnGap={4}
      paddingY={4}
      boxShadow="0px 3px 3px #CFD7DF;"
    >
      <Box pl={!checkNewNavEnabled() ? 4 : 6}>
        <Flex alignItems="center" justifyContent="space-between">
          <TextHeader2 bold>{modifyString(moduleName, StringModifier.TITLE_CASE)} Preferences</TextHeader2>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Header;
